<template>
    <div class="wrapper">
      <div class="wrapper-body">
          <div class="logo">
              <img src="@/assets/image/logo.png" class="auto-img" alt="">
          </div>
          <div class="logo-title">小蜂蜂闪运</div>
          <div class="weixin-logo">
              <div class="icon">
                  <svg t="1710313660689" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1482" width="12" height="12"><path d="M740.672 37.504c156.352 0 283.52 115.584 283.52 258.496 0 44.416-13.056 87.872-36.608 127.04-35.648 57.216-92.672 99.584-161.664 119.744a161.408 161.408 0 0 1-45.184 7.36 52.8 52.8 0 0 1-53.76-52.928c0-29.76 23.68-52.864 53.76-52.864 2.112 0 6.528 0 11.904-2.048 46.336-12.8 82.944-39.168 103.424-74.24 13.952-22.144 20.48-46.72 20.48-72.064 0-83.84-78.72-152.512-174.72-152.512a197.76 197.76 0 0 0-94.72 24.32c-50.816 28.544-80.896 76.16-80.896 128.192v443.904c0 89.984-50.752 172.672-134.848 219.328-45.184 25.408-96 38.272-147.712 38.272-156.288 0-283.52-115.648-283.52-258.56 0-44.352 13.12-87.872 36.608-127.04 35.648-57.216 92.736-99.584 161.664-119.68 19.328-5.312 32.384-7.36 45.184-7.36 30.272 0 53.824 23.36 53.824 52.864a52.8 52.8 0 0 1-53.76 52.928c-2.176 0-6.592 0-11.904 2.048-46.4 13.76-82.944 40.32-103.424 74.176-14.016 22.208-20.48 46.72-20.48 72.128 0 83.84 78.72 152.448 175.616 152.448a197.76 197.76 0 0 0 94.784-24.256c50.752-28.608 80.832-76.224 80.832-128.192V296.192c0-89.984 50.752-172.608 134.848-219.328a283.52 283.52 0 0 1 146.752-39.36z" fill="#999999" p-id="1483"></path></svg>
              </div>
              <div class="subtext">小程序</div>
          </div>
          <button class="submit-btn" @click="submit">打开小程序</button>
      </div>
    </div>
  </template>
  
  <script>
  var ua = navigator.userAgent.toLowerCase()
  var isWXWork = ua.match(/wxwork/i) == 'wxwork'
  var isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
  import { apigetWeixinLink } from '@/api/beecargo/driverlessVehicle/index.js'
import Vconsole from 'vconsole';

  
  export default {
    name: "vehicleCargoOp",
  
    data() {
      return {};
    },
    created(){
      if(isWeixin){
         this.getLink();
      }
      let vConsole;
      if(process.env.NODE_ENV === 'development') vConsole = new Vconsole();
    },
    methods: {
      submit(){
         this.getLink();
      },
      getLink(){
          if(!this.$route.query.vechileName) return this.$toast({title:'车辆信息缺失，请返回重试'})
          return apigetWeixinLink({vechileName:this.$route.query.vechileName}).then(res=>{
              if(res.code == 200){
                location.href = res.data;
              }else{
                this.$toast('生成链接失败，请重试')
              }
          })
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
      .wrapper {
          width:100%;
          height: 100vh;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          .wrapper-body {
              display: flex;
              flex-direction: column;
              height: 400px;
              justify-content: flex-start;
              align-items: center;
              .logo {
                  width: 70px;
                  height: 70px;
                  margin-bottom: 18px;
                  border-radius: 50%;
                  overflow: hidden;
              }
              .auto-img {
                  width: 100%;
                  height: 100%;
              }
              .logo-title {
                  font-size: 16px;
                  color: #333333;
                  margin-bottom: 18px;
              }
              .weixin-logo {
                  display: flex;
                  align-items: center;
                  .icon {
                      width: 12px;
                      height: 12px;
                      font-size: 0;
                      margin-right: 6px;
                  }
                  .subtext {
                      font-size: 14px;
                      color: #999999;
                  }
              }
              .submit-btn {
                  background-color: #07c160;
                  color: #ffffff;
                  font-size: 16px;
                  line-height: 16px;
                  text-align: center;
                  padding: 13px 50px;
                  border-radius: 4px;
                  border: none;
                  position: absolute;
                  left: 50%;
                  bottom: 100px;
                  transform: translateX(-50%);
              }
          }
      }
  </style>